import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface ReportsGeneratingIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const ReportsGeneratingIcon = ({ className, ...props }: ReportsGeneratingIconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    viewBox="0 0 189 161"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M147.734 60.9432H50.7693C49.4613 60.9442 48.2068 61.4644 47.2817 62.389C46.3566 63.3141 45.8369 64.5686 45.8359 65.8766V154.843C45.8369 156.151 46.3566 157.406 47.2817 158.331C48.2068 159.255 49.4613 159.775 50.7693 159.776H147.734C149.042 159.775 150.297 159.256 151.222 158.331C152.147 157.406 152.667 156.151 152.668 154.843V65.8766C152.667 64.5686 152.147 63.3141 151.222 62.389C150.297 61.4639 149.042 60.9442 147.734 60.9432Z"
      fill="#C6C6C6"
    />
    <g
      filter="url(#filter0_f_2981_166427)"
      opacity="0.4"
    >
      <path
        d="M125.663 116.932H87.5957C86.3639 116.932 85.3652 115.934 85.3652 114.702V79.1628C85.3652 77.931 86.3639 76.9324 87.5957 76.9324H125.663C126.894 76.9324 127.893 77.931 127.893 79.1628V114.702C127.893 115.934 126.894 116.932 125.663 116.932Z"
        fill="#F3F3F3"
      />
      <path
        d="M120.978 84.4413H92.2793V86.0769H120.978V84.4413ZM120.978 90.6863H92.2793V92.3219H120.978V90.6863ZM120.978 96.9329H92.2793V98.5683H120.978V96.9329ZM120.978 103.178H92.2793V104.813H120.978V103.178Z"
        fill="white"
      />
    </g>
    <path
      d="M86.6869 85.8139L21.855 99.5849C19.7571 100.031 17.6055 98.2695 17.0495 95.6517L1.00685 20.1251C0.450783 17.5072 1.70075 15.0238 3.7987 14.5781L68.6306 0.807156C70.7282 0.361608 72.8801 2.1225 73.4362 4.74038L89.4788 80.2669C90.0348 82.8848 88.7845 85.3684 86.6869 85.8139Z"
      fill="#E4E4E4"
    />
    <path
      d="M63.3714 15.2892L14.4941 25.6713L15.0858 28.4569L63.9631 18.0748L63.3714 15.2892ZM65.6306 25.9251L16.7533 36.3072L17.345 39.0928L66.2223 28.7108L65.6306 25.9251ZM67.8903 36.5636L19.013 46.9457L19.6047 49.7309L68.482 39.3489L67.8903 36.5636ZM70.1495 47.1996L21.2722 57.5816L21.8639 60.3672L70.7412 49.9852L70.1495 47.1996Z"
      fill="white"
    />
    <path
      d="M75.0781 86.7616L91.029 102.713H75.0781V86.7616Z"
      fill="url(#paint0_linear_2981_166427)"
    />
    <path
      d="M152.667 104.029V67.3276L146.283 60.9432V104.028H152.667V104.029Z"
      fill="#C6C6C6"
    />
    <path
      d="M160.146 107.348L153.268 156.036C152.924 158.47 150.841 160.279 148.383 160.279H50.1215C47.6637 160.279 45.5807 158.47 45.2369 156.036L35.9419 90.2473C35.5227 87.2769 37.8275 84.6235 40.827 84.6235H71.1722C73.6301 84.6235 75.7136 86.4326 76.0573 88.8661L77.2755 97.4817C77.6192 99.9156 79.7023 101.725 82.1601 101.725H155.262C158.261 101.725 160.566 104.379 160.147 107.348H160.146Z"
      fill="url(#paint1_linear_2981_166427)"
    />
    <path
      d="M135.776 138.563H62.7286C62.328 138.562 61.9417 138.417 61.641 138.152C61.3407 137.887 61.1471 137.522 61.0969 137.125L60.1828 129.889C60.1536 129.657 60.1742 129.422 60.243 129.199C60.3119 128.976 60.4271 128.77 60.5815 128.595C60.7355 128.42 60.9253 128.28 61.138 128.184C61.3508 128.088 61.5812 128.038 61.8145 128.038H136.69C136.924 128.038 137.154 128.088 137.367 128.184C137.579 128.28 137.769 128.42 137.923 128.595C138.078 128.77 138.193 128.976 138.262 129.199C138.331 129.422 138.351 129.657 138.322 129.889L137.408 137.125C137.358 137.522 137.164 137.887 136.864 138.152C136.563 138.417 136.177 138.562 135.776 138.563Z"
      fill="#D5D5D5"
    />
    <path
      d="M99.043 138.834H61.3154C61.1161 138.833 60.924 138.681 60.7745 138.404C60.6252 138.127 60.5289 137.746 60.5039 137.331L60.0494 129.768C60.0349 129.526 60.0451 129.28 60.0793 129.047C60.1136 128.814 60.1709 128.599 60.2476 128.416C60.3242 128.233 60.4186 128.087 60.5244 127.986C60.6302 127.886 60.7448 127.834 60.8608 127.834H98.0952C98.2112 127.834 98.3258 127.886 98.4316 127.986C98.5374 128.087 98.6315 128.233 98.7083 128.416C98.7851 128.599 98.8424 128.814 98.8766 129.047C98.9109 129.28 98.9211 129.526 98.9066 129.768L99.043 137.331C99.043 137.779 99.043 137.834 99.043 138.404C99.043 138.701 99.0429 138.373 99.043 138.834Z"
      fill="#C6C6C6"
    />
    <path
      d="M162.519 92.1632L109.658 72.9801C107.947 72.3594 107.126 70.2987 107.823 68.3775L127.937 12.951C128.634 11.0298 130.586 9.97564 132.297 10.5964L185.158 29.7795C186.868 30.4001 187.69 32.4609 186.993 34.3821L166.879 89.8086C166.182 91.7298 164.229 92.7839 162.519 92.1632Z"
      fill="#F3F3F3"
    />
    <path
      d="M172.388 44.6842L132.535 30.2219L131.711 32.4932L171.563 46.9555L172.388 44.6842ZM169.241 53.3563L129.388 38.894L128.564 41.1653L168.416 55.6276L169.241 53.3563ZM166.093 62.0305L126.24 47.5682L125.416 49.8392L165.269 64.3014L166.093 62.0305ZM162.946 70.7025L123.093 56.2403L122.269 58.5116L162.122 72.9738L162.946 70.7025Z"
      fill="white"
    />
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="42"
        id="filter0_f_2981_166427"
        width="44.5273"
        x="84.3652"
        y="75.9324"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          mode="normal"
          result="shape"
        />
        <feGaussianBlur
          result="effect1_foregroundBlur_2981_166427"
          stdDeviation="0"
        />
      </filter>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_2981_166427"
        x1="85.6149"
        x2="66.3346"
        y1="105.274"
        y2="85.994"
      >
        <stop
          offset="0"
          stopColor="#CEC2C2"
          stopOpacity="0"
        />
        <stop
          offset="0.179"
          stopColor="#BCAFAF"
          stopOpacity="0.179"
        />
        <stop
          offset="1"
          stopColor="#6A5B5C"
        />
      </linearGradient>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint1_linear_2981_166427"
        x1="98.0443"
        x2="98.0443"
        y1="84.6235"
        y2="160.28"
      >
        <stop stopColor="#F2F3F3" />
        <stop
          offset="0.927"
          stopColor="#E4E4E4"
        />
      </linearGradient>
    </defs>
  </svg>
);

export default ReportsGeneratingIcon;
